(() => {
  if (window.blackBearAssemblyCart) return;
  window.blackBearAssemblyCart = true;
  const originalFetch = window.fetch.bind(window);
  let queue = Promise.resolve();
  const groupOf = (item) => item.properties?.['_Assembly group'];
  const isService = (item) => Boolean(item.properties?.Equipment);
  const decode = (body) => {
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch { return null; }
    }
    if (body instanceof FormData || body instanceof URLSearchParams) return Object.fromEntries(body.entries());
    return null;
  };
  const send = (url, body) => originalFetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify(body)
  });
  const pairedChange = async (url, options, data) => {
    const base = url.slice(0, url.lastIndexOf('/cart/') + 1);
    const cartResponse = await originalFetch(`${base}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
    if (!cartResponse.ok) throw new Error('Unable to check pre-assembly quantities. Please try again.');
    const cart = await cartResponse.json();
    const selected = data.line ? cart.items[Number(data.line) - 1] : cart.items.find((item) => item.key === String(data.id)) || cart.items.find((item) => String(item.variant_id) === String(data.id));
    const group = selected && groupOf(selected);
    const pair = group ? cart.items.filter((item) => groupOf(item) === group) : [];
    const equipment = pair.find((item) => !isService(item));
    const service = pair.find(isService);
    if (pair.length !== 2 || !equipment || !service) return originalFetch(url, options);
    const quantity = Number(data.quantity);
    const sections = { sections: data.sections, sections_url: data.sections_url };
    if (quantity === 0 && selected === equipment) {
      return send(`${base}cart/update.js`, { ...sections, updates: { [equipment.key]: 0, [service.key]: 0 } });
    }
    if (quantity === 0 && selected === service) {
      const properties = { ...equipment.properties, 'Pre-assembly': 'Standard — assemble it yourself', '_Assembly group': '' };
      const standardResponse = await send(`${base}cart/change.js`, { id: equipment.key, quantity: equipment.quantity, properties });
      if (!standardResponse.ok) return standardResponse;
      const standardCart = await standardResponse.clone().json();
      if (standardCart.errors || standardCart.status) return standardResponse;
      const remainingService = standardCart.items.find((item) => groupOf(item) === group && isService(item));
      if (!remainingService) return standardResponse;
      return send(`${base}cart/update.js`, { ...sections, updates: { [remainingService.key]: 0 } });
    }
    if (!Number.isInteger(quantity) || quantity < 1) return originalFetch(url, options);
    const equipmentResponse = await send(`${base}cart/change.js`, { ...data, line: undefined, id: equipment.key, quantity });
    if (!equipmentResponse.ok) return equipmentResponse;
    const equipmentCart = await equipmentResponse.clone().json();
    if (equipmentCart.errors || equipmentCart.status) return equipmentResponse;
    const updatedEquipment = equipmentCart.items.find((item) => groupOf(item) === group && !isService(item));
    const updatedService = equipmentCart.items.find((item) => groupOf(item) === group && isService(item));
    if (!updatedEquipment || !updatedService) throw new Error('Unable to confirm pre-assembly quantities. Please refresh your basket.');
    if (updatedEquipment.quantity === updatedService.quantity) return equipmentResponse;
    const assemblyResponse = await send(`${base}cart/update.js`, { ...sections, updates: { [updatedService.key]: updatedEquipment.quantity } });
    if (!assemblyResponse.ok) {
      await send(`${base}cart/change.js`, { ...sections, id: updatedEquipment.key, quantity: equipment.quantity });
    }
    return assemblyResponse;
  };
  window.fetch = function (input, options = {}) {
    const address = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    const url = new URL(address, window.location.href);
    const data = decode(options.body);
    if (url.origin !== window.location.origin || !/\/cart\/change(?:\.js)?$/.test(url.pathname) || !data || !Object.hasOwn(data, 'quantity')) return originalFetch(input, options);
    const result = queue.then(() => pairedChange(url.href, options, data));
    queue = result.catch((error) => { console.error('BlackBear pre-assembly basket:', error); });
    return result;
  };
})();
